import React from 'react'
import IconsAdded from './IconsAdded'

function DivLayout({children,divClass,showEndingIcons,iconsColor}) {
  return (
    <div className={`div_layout ${divClass}`}>
        {children}
        {!showEndingIcons&&<IconsAdded iconColor={iconsColor}/>}
    </div>
  )
}

export default DivLayout